import {dataPostRequest, dataPutRequest, deleteRequest, getBaseUrl, getRequest} from "../../utils/request";

export const fileList = (params) => {
  return dataPostRequest('/file/list', params);
}

export const downLoadFileUrl = (url, params) => {
  return getBaseUrl() + "/file/download/" + url;
}

export const getDownloadUrl = (url) =>{
  return getRequest("/file/downloadUrl/" + url + '/true');
}

export const getDownloadUrlNotDecreaseScore = (url)=>{
  return getRequest("/file/downloadUrl/" + url + '/false');
}

export const forStoreFile = (fileId) => {
  return getRequest("/file/forStoreHouse/" + fileId);
}

export const getAuthURL = (data) => {
  return dataPostRequest("/file/auth/upload/" , data);
}



// WEBPACK FOOTER //
// ./src/api/file/file.js